export default __webpack_public_path__ + "static/media/gallery_01.ece427d3.jpg";